import React, { createContext, useEffect, useState } from "react";
import axiosInstance from "../utils/axios-instance";

export const AlferdChatContext = createContext(undefined);

const AlferdChatProvider = ({ children }) => {
  const [conversations, setConversations] = useState({
    totalCount: 0,
    data: [],
  });
  const [currentConversation, setCurrentConversation] = useState(null);

  // ----------------------------------------------- FIND CONVERSATIONS --------------------------------------------

  useEffect(() => {
    const findConversations = async () => {
      try {
        const res = await axiosInstance("/chat/find/conversations");
        setConversations(res.data);
      } catch (error) {
        // console.log(error);
      }
    };

    findConversations();
  }, []);

  // ------------------------------------------------ SELECT CONVERSATION -----------------------------------------
  const handleSelectConversation = (data) => {
    setCurrentConversation(data);
  };

  return (
    <AlferdChatContext.Provider
      value={{ conversations, currentConversation, handleSelectConversation }}
    >
      {children}
    </AlferdChatContext.Provider>
  );
};

export default AlferdChatProvider;
